import { useCreator } from "../creator/CreatorContext";
import { Button } from "../design/primitives";
import { usePreview } from "../preview/PreviewContext";
import css from "./previewBar.module.css";

/**
 * The preview bar — `specs/patron-preview/` FR-2, FR-3.
 *
 * One bar above the real patron header. Nothing else on the page changes: the
 * point of the feature is seeing what a tier actually sees, so a preview that
 * altered the screen would answer a different question than the one asked.
 *
 * It is sticky and rendered by the patron shell, so it persists across every
 * patron route visited while previewing rather than being remembered per screen.
 */
export function PreviewBar() {
  const { creator } = useCreator();
  const { tier, previewing, setTier, exit } = usePreview();

  if (!previewing) return null;

  return (
    <div className={css.bar}>
      <div className={css.left}>
        <span className={css.label}>PREVIEWING THE LIBRARY AS</span>

        <div className={css.chips} role="group" aria-label="Previewed tier">
          {creator.tiers.map((t) => {
            const active = t.id === tier;
            return (
              <button
                key={t.id}
                type="button"
                aria-pressed={active}
                className={`${css.chip} ${active ? css.chipActive : ""}`}
                onClick={() => setTier(t.id)}
              >
                {t.name.toUpperCase()}
              </button>
            );
          })}
        </div>

        {/*
          Stated, not implied by disabled buttons. The owner is checking a
          paywall; "why did nothing happen" is the wrong thing to be wondering.
        */}
        <span className={css.note}>DOWNLOADS ARE DISABLED IN PREVIEW</span>
      </div>

      <Button variant="secondary" size="rail" onClick={exit}>
        EXIT TO STUDIO
      </Button>
    </div>
  );
}
